import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from './use-toast';
import { z } from 'zod';

const newsletterSchema = z.object({
  email: z.string()
    .trim()
    .email('Por favor, insira um email válido')
    .max(254, 'Email muito longo')
    .min(1, 'Email é obrigatório'),
});

export const useNewsletter = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const subscribe = async (email: string) => {
    setIsLoading(true);
    try {
      const validation = newsletterSchema.safeParse({ email });
      if (!validation.success) {
        const firstError = validation.error.errors[0];
        toast({ title: 'Erro de validação', description: firstError.message, variant: 'destructive' });
        return { success: false, error: firstError.message };
      }

      const { data, error } = await supabase.functions.invoke('newsletter', {
        body: { email: validation.data.email },
      });
      if (error) throw error;

      toast({
        title: 'Inscrição realizada!',
        description: 'Obrigado por se inscrever na nossa newsletter.',
      });
      return { success: true, data };
    } catch (error: any) {
      console.error('Newsletter subscription error:', error);
      toast({
        title: 'Erro na inscrição',
        description: 'Tente novamente ou entre em contato conosco.',
        variant: 'destructive',
      });
      return { success: false, error: error.message };
    } finally {
      setIsLoading(false);
    }
  };

  return { subscribe, isLoading };
};
